export { Manage as ManageActionPathPage } from './Manage';
